// client/src/routes/_auth/select-contract.tsx — „Selectare contract", the tenant portal's
// sibling of SCR-AUTH-007.
//
// Under `_auth` for the same reason `/select-organization` is: it is a page with nothing on it
// but the question, and `AuthLayout` is the layout that has no navigation to leak. Needs a
// tenant session — it chooses between the leases `GET /api/v1/portal/contracts` answers with —
// and everybody else is sent where their role lives, the way `/portal` itself does it.
//
// The count is checked here as `/select-organization` checks the memberships: a tenant with one
// contract (or none) has nothing to choose and goes straight on. The contracts are read through
// the same query key every portal screen uses, so the read is cached for the screen that comes
// next rather than made twice. A failed read does NOT redirect — the component renders the
// error with a retry, which is more than a redirect loop could offer.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { listPortalContractsOptions } from '@/client/@tanstack/react-query.gen';
import { DEFAULT_LANDING, forwardRedirect, redirectSearchSchema, safeRedirect } from '@/features/auth/redirect';
import { hasSeveralContracts } from '@/features/portal/scope';
import { SelectContract } from '@/features/portal/SelectContract';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/select-contract')({
  validateSearch: redirectSearchSchema,
  beforeLoad: async ({ context, search }) => {
    const session = await ensureSession();
    if (!session) throw redirect({ to: '/login', search: forwardRedirect(search) });
    if (session.role !== 'tenant') throw redirect({ href: DEFAULT_LANDING });

    const contracts = await context.queryClient
      .ensureQueryData(listPortalContractsOptions())
      .catch(() => undefined);
    if (contracts !== undefined && !hasSeveralContracts(contracts)) {
      throw redirect({ href: safeRedirect(search.redirect ?? '/portal') });
    }
  },
  component: SelectContractScreen,
});

function SelectContractScreen() {
  const search = Route.useSearch();
  return <SelectContract search={search} />;
}
